import * as ExcelJS from 'exceljs';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExcelExportService {
  async exportToExcel(
    jsonData: Record<string, unknown>[],
    fileName: string,
    headerMapping: Record<string, string>
  ): Promise<void> {
    // Customize header names
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');

    // Define Columns
    const columns = Object.keys(headerMapping).map(key => ({
      header: headerMapping[key],
      key,
      width: 20,
    }));

    worksheet.columns = columns;

    // Add Rows
    jsonData.forEach(row => {
      worksheet.addRow(row ? row : '');
    });

    // Custom Styles for Header Row
    worksheet.getRow(1).eachCell(cell => {
      cell.font = {
        bold: true,
        size: 10,
        color: { argb: '3b424f' },
        name: 'Inter',
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DDF6EB' },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Custom Styles for Data Rows
    worksheet.eachRow((row, rowIndex) => {
      if (rowIndex !== 1) {
        row.eachCell(cell => {
          cell.font = { size: 10, color: { argb: '3b424f' }, name: 'Inter' }; // Black Text
          cell.alignment = { horizontal: 'left' };
        });
      }
    });

    // Generate and Save Excel File
    const buffer = await workbook.xlsx.writeBuffer();
    const data = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(data, `${fileName}.xlsx`);
  }
}
